import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import RatingsActions, { RatingsRedux, RatingsTypes } from '../Redux/RatingsRedux'
import { notificationFail } from '../Redux/NotificationActions'

const ratingsCrudObservable = createCRUDObservable({
  mainRedux: RatingsRedux,
  reduxPath: 'ratings',
})

const ratingsExcelEpic = (action$, store, { Api }) =>
  action$.ofType(RatingsTypes.RatingsExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.ratings.getRatingsExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            RatingsActions.RatingsExcelSuccess(),
          ]
        })
    ))

export const ratingsObservers = Object.assign({}, ratingsCrudObservable.observers, {})

export const ratingsEpic = combineEpics(
  ratingsCrudObservable.epic,
  ratingsExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/RatingsObservable.js